// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionUpgradeModal_root__2PZBy","container":"SubscriptionUpgradeModal_container__EY3w-","body":"SubscriptionUpgradeModal_body__g-YJV"};